// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-wrapper {
  width: 100%;
  padding: 0 0 20px 0;
  /* Removed top padding */
  background-color: transparent;
}

.skeleton-grid-container {
  display: flex !important;
  gap: 15px;
  padding: 0 20px;
  margin-bottom: 25px;
  overflow: hidden;
  width: 100%;
}

.skeleton-grid-container .skeleton-card {
  flex: 0 0 17%;
  /* Shows roughly 5.5 cards on desktop */
  min-width: 140px;
}

.skeleton-grid-container.portrait .skeleton-card {
  flex: 0 0 14%;
  /* Denser for portraits */
  min-width: 110px;
}

.skeleton-grid-container.circle .skeleton-card {
  flex: 0 0 12%;
  /* Even denser for circles */
  min-width: 90px;
}

.skeleton-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 15px;
  margin-top: 10px;
}

.skeleton-header-title {
  width: 200px;
  height: 24px;
  border-radius: 4px;
}

.skeleton-header-link {
  width: 80px;
  height: 18px;
  border-radius: 4px;
}

.skeleton-card {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.skeleton-card.circle-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skeleton-image {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 10px;
}

.landscape-ratio {
  aspect-ratio: 16/9;
}

.portrait-ratio {
  aspect-ratio: 2/3;
}

.circle-ratio {
  aspect-ratio: 1/1;
  border-radius: 50% !important;
}

.skeleton-info {
  padding: 0 4px;
}

.skeleton-title-sm {
  width: 80%;
  height: 14px;
  margin-bottom: 6px;
  border-radius: 4px;
}

.skeleton-title-xs {
  width: 60%;
  height: 12px;
  border-radius: 4px;
}

.skeleton-text-sm {
  width: 50%;
  height: 10px;
  border-radius: 4px;
}

.center-margin {
  margin-left: auto;
  margin-right: auto;
}

/* Banner Layout */
.skeleton-banner {
  width: 100%;
  height: 380px;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  padding: 20px;
}

.skeleton-banner-content {
  position: absolute;
  bottom: 60px;
  left: 40px;
  width: 40%;
  z-index: 2;
}

.skeleton-title {
  width: 80%;
  height: 48px;
  margin-bottom: 24px;
  border-radius: 6px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.skeleton-text-short {
  width: 60%;
  height: 24px;
  margin-bottom: 24px;
  border-radius: 4px;
}

.skeleton-button-row {
  display: flex;
  gap: 15px;
}

.skeleton-button {
  width: 140px;
  height: 48px;
  border-radius: 8px;
}

.skeleton-arrow-l,
.skeleton-arrow-r {
  position: absolute;
  top: 20px;
  width: 24px;
  height: 24px;
  border-radius: 50% !important;
}

.skeleton-arrow-l {
  left: 20px;
}

.skeleton-arrow-r {
  right: 20px;
}

/* Base Shimmer Effect */
.square {
  position: relative;
  overflow: hidden;
  background: #242424;
}

.square::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.05) 20%,
      rgba(255, 255, 255, 0.1) 60%,
      rgba(255, 255, 255, 0));
  transform: translateX(-100%);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 768px) {
  .skeleton-banner {
    height: 300px;
  }

  .skeleton-banner-content {
    width: 80%;
    bottom: 30px;
    left: 20px;
  }

  .skeleton-grid-container {
    padding: 0 10px;
  }

  .skeleton-grid-container .skeleton-card {
    flex: 0 0 35%;
    /* Shows roughly 2.5 cards on mobile */
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/SkeletonLoader.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;6BAI2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,gBAAgB;EAClB;AACF","sourcesContent":[".skeleton-wrapper {\n  width: 100%;\n  padding: 0 0 20px 0;\n  /* Removed top padding */\n  background-color: transparent;\n}\n\n.skeleton-grid-container {\n  display: flex !important;\n  gap: 15px;\n  padding: 0 20px;\n  margin-bottom: 25px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.skeleton-grid-container .skeleton-card {\n  flex: 0 0 17%;\n  /* Shows roughly 5.5 cards on desktop */\n  min-width: 140px;\n}\n\n.skeleton-grid-container.portrait .skeleton-card {\n  flex: 0 0 14%;\n  /* Denser for portraits */\n  min-width: 110px;\n}\n\n.skeleton-grid-container.circle .skeleton-card {\n  flex: 0 0 12%;\n  /* Even denser for circles */\n  min-width: 90px;\n}\n\n.skeleton-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  margin-bottom: 15px;\n  margin-top: 10px;\n}\n\n.skeleton-header-title {\n  width: 200px;\n  height: 24px;\n  border-radius: 4px;\n}\n\n.skeleton-header-link {\n  width: 80px;\n  height: 18px;\n  border-radius: 4px;\n}\n\n.skeleton-card {\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.skeleton-card.circle-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.skeleton-image {\n  width: 100%;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.landscape-ratio {\n  aspect-ratio: 16/9;\n}\n\n.portrait-ratio {\n  aspect-ratio: 2/3;\n}\n\n.circle-ratio {\n  aspect-ratio: 1/1;\n  border-radius: 50% !important;\n}\n\n.skeleton-info {\n  padding: 0 4px;\n}\n\n.skeleton-title-sm {\n  width: 80%;\n  height: 14px;\n  margin-bottom: 6px;\n  border-radius: 4px;\n}\n\n.skeleton-title-xs {\n  width: 60%;\n  height: 12px;\n  border-radius: 4px;\n}\n\n.skeleton-text-sm {\n  width: 50%;\n  height: 10px;\n  border-radius: 4px;\n}\n\n.center-margin {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Banner Layout */\n.skeleton-banner {\n  width: 100%;\n  height: 380px;\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n.skeleton-banner-content {\n  position: absolute;\n  bottom: 60px;\n  left: 40px;\n  width: 40%;\n  z-index: 2;\n}\n\n.skeleton-title {\n  width: 80%;\n  height: 48px;\n  margin-bottom: 24px;\n  border-radius: 6px;\n}\n\n.skeleton-text {\n  width: 100%;\n  height: 16px;\n  margin-bottom: 16px;\n  border-radius: 4px;\n}\n\n.skeleton-text-short {\n  width: 60%;\n  height: 24px;\n  margin-bottom: 24px;\n  border-radius: 4px;\n}\n\n.skeleton-button-row {\n  display: flex;\n  gap: 15px;\n}\n\n.skeleton-button {\n  width: 140px;\n  height: 48px;\n  border-radius: 8px;\n}\n\n.skeleton-arrow-l,\n.skeleton-arrow-r {\n  position: absolute;\n  top: 20px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50% !important;\n}\n\n.skeleton-arrow-l {\n  left: 20px;\n}\n\n.skeleton-arrow-r {\n  right: 20px;\n}\n\n/* Base Shimmer Effect */\n.square {\n  position: relative;\n  overflow: hidden;\n  background: #242424;\n}\n\n.square::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg,\n      rgba(255, 255, 255, 0) 0,\n      rgba(255, 255, 255, 0.05) 20%,\n      rgba(255, 255, 255, 0.1) 60%,\n      rgba(255, 255, 255, 0));\n  transform: translateX(-100%);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@media (max-width: 768px) {\n  .skeleton-banner {\n    height: 300px;\n  }\n\n  .skeleton-banner-content {\n    width: 80%;\n    bottom: 30px;\n    left: 20px;\n  }\n\n  .skeleton-grid-container {\n    padding: 0 10px;\n  }\n\n  .skeleton-grid-container .skeleton-card {\n    flex: 0 0 35%;\n    /* Shows roughly 2.5 cards on mobile */\n    min-width: 100px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
